import React, { Component } from 'react';
import Flag from 'react-country-flag';
import FlagSpecial from '../flag-special';
import { getCountryCode } from '../../utils/country-code';
import { translate } from '../../utils/lang-adapters';


class MatchHeader extends Component {

  renderStatusResult() {

    if (this.props.gameInfo.status === "Played"
      || (this.props.gameInfo.status === 'Playing' && typeof this.props.gameInfo.statusLive === 'undefined')) {
      return (
        <span className="gamestatus">Terminado</span>
      )
    } else if (this.props.gameInfo.status === "Fixture") {
      return (
        <span className="gamestatus">{this.props.gameInfo.time_utc.substring(0, 5)}</span>
      )
    } else if (this.props.gameInfo.status === 'Playing' && this.props.gameInfo.statusLive === 'Playing') {
      if (this.props.gameInfo.match_period === "HT") {
        return (
          <span className="gamestatus-live">Intervalo</span>
        )
      } else {
        return (
          <span className="gamestatus-live">
            {this.props.gameInfo.minute}{
              ([45, 90, 105, 120].includes(this.props.gameInfo.minute) && this.props.gameInfo.minute_extra > 0) &&
              (' + ' + this.props.gameInfo.minute_extra)
            }<span className="live-flash">'</span>
          </span>
        )
      }

    } else { return (<span className="gamestatus">Cancelado</span>) }
  }

  render() {

    return (
      <div className="teamsHeader">
        <div className="stats-title">
          <p className="team-name">
            <img src="/img/ball.svg" alt="" width="20" />
          </p>
          <h1>
            {
              translate(this.props.gameInfo.team_A_name)
            }
            -
            {
              translate(this.props.gameInfo.team_B_name)
            }
          </h1>
        </div>
        <div className="stat-area">
          <table className="table-stats">
            <tbody>
              <tr className="trstats">
                <td className="logo-teams-header">
                  <img src={"https://academia.r.worldssl.net/addons/default/modules/stats/img/team/150x150/" + this.props.gameInfo.team_A_id + ".png"} alt={this.props.gameInfo.team_A_name} border="0"></img>
                  <p>
                    {
                      translate(this.props.gameInfo.team_A_name)
                    }
                  </p>
                </td>
                <td className="td-stats-data">
                  <ul className="match-head-score">
                    <li className="f-score-odd">
                      {this.props.gameInfo.fs_A} - {this.props.gameInfo.fs_B}
                    </li>
                    {
                      this.props.gameInfo.ets_A !== '' &&
                      this.props.gameInfo.ets_B !== '' &&
                      <li className="f-score-extratime">
                        (prol.{this.props.gameInfo.ets_A} - {this.props.gameInfo.ets_B})
                      </li>
                    }
                    {
                      this.props.gameInfo.ps_A !== '' &&
                      this.props.gameInfo.ps_B !== '' &&
                      <li className="f-score-penalty">
                        (pen.{this.props.gameInfo.ps_A} - {this.props.gameInfo.ps_B})
                      </li>
                    }
                    <li className="gamestatus">
                      {this.renderStatusResult()}
                    </li>
                  </ul>
                  <ul className="match-head-score">
                    <li className="game_date">
                      <b>{this.props.gameInfo.date_utc}</b>
                    </li>
                    <li className="competition-stat-name">
                      {(getCountryCode(this.props.gameInfo.area_name) !== ""
                        ? <Flag countryCode={getCountryCode(this.props.gameInfo.area_name)} svg loading="lazy" alt={'Bandeira de ' + this.props.gameInfo.area_name} className="flagsvg" />
                        : <FlagSpecial code={this.props.gameInfo.area_name} />
                      )}
                      {
                        translate(this.props.gameInfo.competition_name)
                      }
                    </li>
                    <li className="season-name">
                      {
                        translate(this.props.gameInfo.season_name)
                      }
                    </li>
                    <li className="round-name">
                      {
                        translate(this.props.gameInfo.round_name)
                      }
                    </li>
                  </ul>
                </td>
                <td className="logo-teams-header">
                  <img src={"https://academia.r.worldssl.net/addons/default/modules/stats/img/team/150x150/" + this.props.gameInfo.team_B_id + ".png"} title={this.props.gameInfo.team_B_name} alt="" border="0"></img>
                  <p>
                    {
                      translate(this.props.gameInfo.team_B_name)
                    }
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p className="text-note">Fonte de dados: estatísticas do <a href={this.props.gameInfo.linkAuthor}>{this.props.gameInfo.team_A_name} vs {this.props.gameInfo.team_B_name} na Academia das Apostas</a>.</p>
        </div>
      </div>
    );
  }
}
export default MatchHeader;